<div class="modal-dialog" role="document">
  <div class="modal-content bd-0">
    <div class="modal-header pd-y-20 pd-x-25">
      <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{ data.title }}</h6>
      <button type="button" class="btn-close" (click)="dialogRef.close(false);" aria-label="Sluiten"></button>
    </div>
    <div class="modal-body p-5">
      @if (data.problems) {
        <ul class="mg-b-5">
          @for (problem of data.problems; track $index) {
            <li [class.confirm-problem--warning]="!problem.isError" [class.confirm-problem--error]="problem.isError">
              <i class="fas" [ngClass]="problem.isError ? 'fa-exclamation-circle' : 'fa-exclamation-triangle'"></i>&nbsp;{{ problem.text }}
            </li>
          }
        </ul>
      } @else if (data.template) {
        <ng-container [ngTemplateOutlet]="data.template"></ng-container>
      } @else {
        <p class="mg-b-5" [innerHTML]="getSafeHtml()"></p>
      }
    </div>

    <div class="modal-footer">
      <div class="col-6">
        @if (data.cancelonly.valueOf() === false) {
          <button type="button" class="btn btn-block btn-primary" (click)="dialogRef.close(true)">{{ okBtnText | translate }}</button>
        }
      </div>
      <div class="col-6">
        @if (data.okonly.valueOf() === false) {
          <button type="button" class="btn btn-block btn-secondary" (click)="dialogRef.close(false);">{{cancelBtnText | translate }}</button>
        }
      </div>
    </div>

  </div>
</div>
